import { Injectable } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { MultiStepFormItemModel } from '@libs/form/models';
import { Observable, ReplaySubject } from 'rxjs';

export interface FormConfig {
  form: MultiStepFormItemModel;
  control: FormGroup;
}

@Injectable()
export class FormConfigService {
  private readonly config$: ReplaySubject<FormConfig> = new ReplaySubject<FormConfig>(1);

  public setConfig(config: FormConfig): void {
    this.config$.next(config);
  }

  public getConfig(): Observable<FormConfig> {
    return this.config$.asObservable();
  }
}
